import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandant-client-config';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantClientConfigEffects {

    MandantClientConfig$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANT_CLIENT_CONFIG),
        mergeMap((x: ac.GetMandantClientConfigAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantClientConfig().pipe(
                map((result: any) => {
                    return new ac.GetMandantClientConfigErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantClientConfigFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
